import { Injectable, signal } from '@angular/core';

export type ToastKind = 'success' | 'error' | 'info';

export type ToastItem = {
  id: number;
  kind: ToastKind;
  message: string;
};

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 0;
  readonly items = signal<ToastItem[]>([]);

  success(message: string): void {
    this.push('success', message);
  }

  error(message: string): void {
    this.push('error', message);
  }

  info(message: string): void {
    this.push('info', message);
  }

  dismiss(id: number): void {
    this.items.update((list) => list.filter((item) => item.id !== id));
  }

  private push(kind: ToastKind, message: string): void {
    const text = message.trim();
    if (!text) {
      return;
    }
    const id = ++this.nextId;
    this.items.update((list) => [...list.slice(-2), { id, kind, message: text }]);
    window.setTimeout(() => this.dismiss(id), 3800);
  }
}
